import {ReactElement, ReactNode} from 'react'
import {Trans} from 'react-i18next'
import {withdrawalPaymentVendors} from '@bdswiss/common-enums'

import messages from '../../../../../../assets/messages'
import {ReactComponent as AppleIcon} from '../../../../../../assets/images/apple-brands.svg'
import {ReactComponent as VisaLogoIcon} from '../../../../../../assets/images/visa_logo_icon.svg'
import {ReactComponent as MastercardLogoIcon} from '../../../../../../assets/images/mastercard_logo_icon.svg'
import {ReactComponent as GoogleLogoIcon} from '../../../../../../assets/images/logo-google.svg'
import {Currency} from '../../../../../../graphql/types'
import {useStyles} from './styles'
import {getFormattedAmount} from '../../../../../../common/utils'

type AmountToRefundItemProps = {
  amount: number
  currency: Currency | null
  details: string
  vendor: string
}

function AmountToRefundItem(props: AmountToRefundItemProps): ReactElement {
  const classes = useStyles()
  const {amount, currency, details, vendor} = props

  const vendorLabel = withdrawalPaymentVendors[vendor]?.label

  let icons: ReactElement
  let refundText: ReactNode

  switch (vendor) {
    case withdrawalPaymentVendors.enovipayRefund.value:
    case withdrawalPaymentVendors.creditDebitCard.value: {
      icons = (
        <>
          <VisaLogoIcon className={classes.icon} />
          <MastercardLogoIcon className={classes.icon} />
        </>
      )

      refundText = (
        <Trans
          {...messages.amountToRefund}
          values={{amount: getFormattedAmount({currency, amount}), cardNumber: details}}
          components={[<span className={classes.amount}>amount</span>]}
        />
      )
      break
    }
    case withdrawalPaymentVendors.enovipayMobileWalletRefund.value: {
      icons = (
        <>
          <AppleIcon className={classes.icon} />
          <GoogleLogoIcon className={classes.icon} />
        </>
      )

      refundText = (
        <Trans
          {...messages.amountToRefundMobileWallets}
          values={{amount: getFormattedAmount({currency, amount})}}
          components={[<span className={classes.amount}>amount</span>]}
        />
      )
      break
    }
    default:
      icons = <></>
      refundText = ''
  }

  return (
    <div className={classes.container}>
      {<div className={classes.icons}>{icons}</div>}
      <div>{refundText}</div>
      {vendorLabel ? <div className={classes.vendor}>{vendorLabel}</div> : null}
    </div>
  )
}

export {AmountToRefundItem}
